import gql from 'graphql-tag';

export const getApplication = gql`
  query ($applicationId: Int) {
    getApplication (applicationId: $applicationId) {
      applicationId
      name
      remark
      date
      apiKey
      apiKeyHash
      sdkKey
      configuration
      checkInInterval
      checkOutInterval
      inversedAttendance
      apiMasterKeyId
      sdkMasterKeyId
      minisitePushLimit
      apiLimit
      allowSMS
      allowEmail
      smsCount
      emailCount
    }
  }
`
